export enum EstadoModalEnum {
  Fechado = 1,
  Confirmacao = 2,
  Sucesso = 3,
  Erro = 4,
  Loading = 5
}
